import React from 'react'
import { Container, LeadFormHorizontalHalfMobPreloader } from '@rst/ui-ts'
import styled from 'styled-components'

export const LeadFormHorizontalHalfMob = ({ data }: any) => {
	return (
		<StyledContainer>
			<LeadFormHorizontalHalfMobPreloader {...data} />
		</StyledContainer>
	)
}

const StyledContainer = styled(Container)<{ height?: number }>`
	/* padding-top: 64px;
	padding-bottom: 32px; */
	padding-left: 18px;
	padding-right: 18px;
	display: flex;
	justify-content: center;
`
